import { createSlice } from '@reduxjs/toolkit';
import pickXApi from "./pickX.api";
import {submitParlayAsync} from "./pickX.thunks";

import {
    handleParlayCancelled,
    handleParlayCompleted,
    handleParlayPlaced,
    handleParlayResultsChanged,
    handlePlaceParlayFailed,
    handleSubmitParlayRejected
} from "./handlers/parlaysHandlers";

import {
    handleContestCancelled,
    handleContestRemoved,
    handleContestsUpdated,
    handleContestsCreated,
    handleContestStarted,
    handleContestValuesUpdated,
    handleContestCompleted
} from "./handlers/contestsHandlers";

import {
    handlePreSelectedParlayCancelled,
    handlePreSelectedParlayChanged,
    handlePreSelectedParlayCreated,
    handlePreSelectedParlayDeleted,
    handlePreSelectedParlayExpired
} from "./handlers/preSelectedParlaysHandlers";

import {
    handleSubmitParlayPending,
    handleGetContestsLobbyDataFulfilled,
    handleGetContestsByIdsFulfilled,
    handleGetActiveUserParlaysFulfilled,
    handleGetPreSelectedParlaysLobbyDataFulfilled,
    handleGetPreSelectedParlayByIdFulfilled,
    handleGetUserParlaysHistoryFulfilled, handleGetPrizeAssetByIdFulfilled
} from "./handlers/pickXApiHandlers";

const initialState = {
    contests: [],
    userParlays: [],
    selectedParlayId : null,
    preSelectedParlays: [],
    placingParlayState: {
        placedParlayId: null,
        status: null,
        error: null,
    },
    prizeAssets: [],
    partners: []
};

const pickXSlice = createSlice({
    name: 'pickX',
    initialState,
    reducers: {
        addUserParlay: (state, action) => {
            state.userParlays.push(action.payload);
        },
        removeUserParlay: (state, action) => {
            const parlayId = action.payload;
            state.userParlays = state.userParlays.filter(parlay => parlay.Id !== parlayId);
        },
        updateParlay: (state, action)=>{
            const updatedParlay = action.payload;
            const index = state.userParlays.findIndex(parlay => parlay.Id === updatedParlay.Id);
            if (index !== -1)
                state.userParlays[index] = updatedParlay;
        },
        setSelectedParlayId: (state, action)=>{
            state.selectedParlayId = action.payload;
        },
        clearAllPicks:(state, action)=>{
            const parlayId = action.payload;
            const index = state.userParlays.findIndex(parlay => parlay.Id === parlayId);
            if (index !== -1)
                state.userParlays[index].ContestsPicks = {};
        },
        removeContestPick:(state, action)=>{
            const {parlayId, contestId} = action.payload;
            const index = state.userParlays.findIndex(parlay => parlay.Id === parlayId);
            if (index !== -1)
                delete state.userParlays[index].ContestsPicks[contestId]
        },
        clearPlacingParlayState: (state) => {
            state.placingParlayState = {
                status: null,
                error: null,
                lastPlacedParlay: state.placingParlayState.lastPlacedParlay,
            };
        }
    },
    extraReducers: (builder) => {

        builder.addCase("ws/parlayPlaced", handleParlayPlaced);
        builder.addCase("ws/placeParlayFailed", handlePlaceParlayFailed);
        builder.addCase("ws/parlayResultsChanged", handleParlayResultsChanged);
        builder.addCase("ws/parlayCancelled", handleParlayCancelled);
        builder.addCase("ws/parlayCompleted", handleParlayCompleted);

        builder.addCase("ws/contestCompleted", handleContestCompleted);
        builder.addCase("ws/contestCancelled", handleContestCancelled);
        builder.addCase("ws/contestRemoved", handleContestRemoved);
        builder.addCase("ws/contestsUpdated", handleContestsUpdated);
        builder.addCase("ws/contestsCreated", handleContestsCreated);
        builder.addCase("ws/contestStarted", handleContestStarted);
        builder.addCase("ws/contestValuesUpdated", handleContestValuesUpdated);

        builder.addCase("ws/preSelectedParlayChanged", handlePreSelectedParlayChanged);
        builder.addCase("ws/preSelectedParlayCreated", handlePreSelectedParlayCreated);
        builder.addCase("ws/preSelectedParlayDeleted", handlePreSelectedParlayDeleted);
        builder.addCase("ws/preSelectedParlayExpired", handlePreSelectedParlayExpired);
        builder.addCase("ws/preSelectedParlayCancelled", handlePreSelectedParlayCancelled);

        //todo: implement handlers
        builder.addCase("ws/rollingPrizeChanged", (state, action)=>{

        });

        builder.addCase(submitParlayAsync.rejected, handleSubmitParlayRejected);
        builder.addMatcher(pickXApi.endpoints.submitParlay.matchPending, handleSubmitParlayPending);
        builder.addMatcher(pickXApi.endpoints.getContestsLobbyData.matchFulfilled, handleGetContestsLobbyDataFulfilled );
        builder.addMatcher(pickXApi.endpoints.getContestsByIds.matchFulfilled, handleGetContestsByIdsFulfilled );
        builder.addMatcher(pickXApi.endpoints.getActiveUserParlays.matchFulfilled, handleGetActiveUserParlaysFulfilled);
        builder.addMatcher(pickXApi.endpoints.getUserParlaysHistory.matchFulfilled, handleGetUserParlaysHistoryFulfilled);
        builder.addMatcher(pickXApi.endpoints.getPreSelectedParlaysLobbyData.matchFulfilled, handleGetPreSelectedParlaysLobbyDataFulfilled);
        builder.addMatcher(pickXApi.endpoints.getPreSelectedParlayById.matchFulfilled, handleGetPreSelectedParlayByIdFulfilled);
        builder.addMatcher(pickXApi.endpoints.getPrizeAssetById.matchFulfilled, handleGetPrizeAssetByIdFulfilled);
    }
});

export const {
    addUserParlay,
    updateParlay,
    setSelectedParlayId,
    clearAllPicks,
    removeContestPick,
    clearPlacingParlayState,
    removeUserParlay
} = pickXSlice.actions;

export default pickXSlice;